import * as PATHS from '@/constants/path';
import { request } from '@/services/api/request';
import { URLParamBuilder } from '@/utils/functions';

/**
 * Carat integration app (CLICKUP-86cb5zayy). Reading and installing lives on
 * the Laravel partner API; the app is only reachable with the Deal Manager
 * module (the API answers 403 otherwise).
 */
export function fetchCaratIntegrationRequest() {
  return request<any>(PATHS.CARAT_INTEGRATION, { method: 'GET' });
}

/** Provisions the Carat lead source, its scoped API key and the ingest id. */
export function installCaratIntegrationRequest() {
  return request<any>(PATHS.CARAT_INTEGRATION, { method: 'POST' });
}

/** PATCH so untouched options keep their stored value. */
export function updateCaratIntegrationRequest({ data }: { data: Record<string, unknown> }) {
  return request<any>(PATHS.CARAT_INTEGRATION, { method: 'PATCH', data });
}

export function uninstallCaratIntegrationRequest() {
  return request<any>(PATHS.CARAT_INTEGRATION, { method: 'DELETE' });
}

export function fetchCaratPlanningsRequest({ leadId }: { leadId: string }) {
  const url = URLParamBuilder(PATHS.CARAT_PLANNINGS, {
    queryString: { lead: leadId },
  }, false);
  return request<any>(url, { method: 'GET' });
}

export function fetchCaratPlanningRequest({ planningId }: { planningId: string }) {
  const url = URLParamBuilder(PATHS.CARAT_PLANNING, {
    params: { planningId },
  }, false);
  return request<any>(url, { method: 'GET' });
}
